(() => {
  const root = document.querySelector('[data-aromaorgan-tech]');
  if (!root || root.dataset.checkoutInitialized) return;
  root.dataset.checkoutInitialized = 'true';

  const cart = root.querySelector('[data-aroma-cart]');
  const popup = root.querySelector('[data-aroma-waitlist]');
  const form = root.querySelector('[data-aroma-form]');
  if (!cart || !popup || !form) return;
  const email = form.elements.email;
  const continueButton = form.querySelector('[data-aroma-continue]');
  const joinButton = popup.querySelector('[data-aroma-join]');
  const error = form.querySelector('[data-aroma-error]');
  const quantityInput = cart.querySelector('[data-aroma-quantity]');
  const checkoutButton = cart.querySelector('[data-aroma-checkout]');
  const backButton = cart.querySelector('[data-aroma-cart-back]');
  const offer = popup.querySelector('[data-aroma-offer]');
  const success = popup.querySelector('[data-aroma-success]');
  const contactEmails = new Set();
  const joinedEmails = new Set();
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  let quantity = 0;
  let submitting = false;
  let scrollTop = 0;
  let trigger = null;

  const renderCart = () => {
    cart.querySelector('[data-aroma-cart-empty]').hidden = quantity > 0;
    cart.querySelector('[data-aroma-cart-item]').hidden = quantity === 0;
    cart.querySelector('[data-aroma-summary]').hidden = quantity === 0;
    checkoutButton.disabled = quantity === 0;
    quantityInput.value = Math.max(1, quantity);
    cart.querySelector('[data-aroma-quantity-minus]').disabled = quantity <= 1;
    cart.querySelector('[data-aroma-quantity-plus]').disabled = quantity >= 99;
    cart.querySelector('[data-aroma-line-total]').textContent = money.format(quantity * 399);
    cart.querySelector('[data-aroma-total]').textContent = money.format(quantity * 399);
  };

  const clearError = () => {
    error.hidden = true;
    error.textContent = '';
    email.removeAttribute('aria-invalid');
  };
  const showError = message => {
    error.textContent = message;
    error.hidden = false;
  };
  const setView = view => {
    cart.querySelectorAll('[data-aroma-view]').forEach(element => { element.hidden = element.dataset.aromaView !== view; });
    cart.querySelector('[data-aroma-cart-title]').textContent = view === 'contact' ? 'Checkout' : 'Cart';
    backButton.hidden = view !== 'contact';
    clearError();
    if (view === 'contact') email.focus({ preventScroll: true });
  };
  const openCart = () => {
    if (cart.open) return;
    trigger = document.activeElement;
    const menuToggle = root.querySelector('#navToggle');
    if (menuToggle?.getAttribute('aria-expanded') === 'true') menuToggle.click();
    scrollTop = window.scrollY;
    document.body.style.setProperty('--aroma-scroll-top', `${-scrollTop}px`);
    document.body.style.setProperty('--aroma-scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`);
    document.body.classList.add('aroma-scroll-locked');
    setView('cart');
    cart.showModal();
  };
  const closePopup = () => { if (popup.open) popup.close(); };
  const closeCart = () => {
    closePopup();
    if (cart.open) cart.close();
  };
  cart.addEventListener('close', () => {
    closePopup();
    const previousBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    document.body.classList.remove('aroma-scroll-locked');
    document.body.style.removeProperty('--aroma-scroll-top');
    document.body.style.removeProperty('--aroma-scrollbar-width');
    window.scrollTo({ top: scrollTop, behavior: 'instant' });
    trigger?.focus({ preventScroll: true });
    requestAnimationFrame(() => { document.documentElement.style.scrollBehavior = previousBehavior; });
  });
  popup.addEventListener('close', () => {
    if (cart.open && !form.hidden) continueButton.focus({ preventScroll: true });
  });
  [cart, popup].forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  });

  root.querySelectorAll('[data-aroma-add]').forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    quantity = Math.min(99, quantity + 1);
    renderCart();
    openCart();
  }));
  root.querySelectorAll('[data-aroma-cart-close]').forEach(button => button.addEventListener('click', closeCart));
  root.querySelectorAll('[data-aroma-waitlist-close]').forEach(button => button.addEventListener('click', closePopup));
  cart.querySelector('[data-aroma-remove]').addEventListener('click', () => { quantity = 0; renderCart(); });
  cart.querySelector('[data-aroma-quantity-minus]').addEventListener('click', () => { quantity = Math.max(1, quantity - 1); renderCart(); });
  cart.querySelector('[data-aroma-quantity-plus]').addEventListener('click', () => { quantity = Math.min(99, quantity + 1); renderCart(); });
  quantityInput.addEventListener('change', () => {
    quantity = Math.min(99, Math.max(1, Number.parseInt(quantityInput.value, 10) || 1));
    renderCart();
  });
  checkoutButton.addEventListener('click', () => { if (quantity > 0) setView('contact'); });
  backButton.addEventListener('click', () => setView('cart'));
  email.addEventListener('input', clearError);

  const validateEmail = () => {
    email.value = email.value.trim();
    if (!email.checkValidity()) {
      showError('Please enter a valid email address first.');
      email.setAttribute('aria-invalid', 'true');
      email.focus({ preventScroll: true });
      return false;
    }
    clearError();
    return true;
  };
  const setSubmitting = (value, isContact) => {
    submitting = value;
    email.readOnly = value;
    continueButton.disabled = value;
    joinButton.disabled = value;
    continueButton.textContent = value && isContact ? 'Sending...' : 'Continue to shipping';
    joinButton.textContent = value && !isContact ? 'Sending...' : 'Join the waitlist';
  };
  const sendResearch = async suffix => {
    const data = new FormData(form);
    const sourceUrl = new URL(window.location.href);
    sourceUrl.hash = '';
    data.set('email', email.value.trim());
    data.set('project', `${form.elements.project.value.trim()}${suffix}`);
    data.set('source_url', sourceUrl.toString());
    const response = await fetch(form.action, { method: 'POST', body: data });
    const result = await response.json().catch(() => null);
    if (!response.ok || result?.success !== true) throw new Error('Failed to send. Please try again.');
  };
  const showSuccess = () => {
    offer.hidden = true;
    success.hidden = false;
    popup.setAttribute('aria-labelledby', success.querySelector('h2').id);
    if (popup.open) success.querySelector('button').focus({ preventScroll: true });
  };
  const showOffer = () => {
    const alreadyJoined = joinedEmails.has(email.value.trim().toLowerCase());
    offer.hidden = alreadyJoined;
    success.hidden = !alreadyJoined;
    popup.setAttribute('aria-labelledby', (alreadyJoined ? success : offer).querySelector('h2').id);
    if (!popup.open) popup.showModal();
  };

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submitting || quantity === 0 || !validateEmail()) return;
    const address = email.value.trim().toLowerCase();
    if (!contactEmails.has(address)) {
      setSubmitting(true, true);
      try {
        await sendResearch('-email');
        contactEmails.add(address);
        window.igEvents = window.igEvents || [];
        window.igEvents.push({ event: 'form_submited' });
      } catch (_error) {
        showError('Failed to send. Please try again.');
        return;
      } finally {
        setSubmitting(false, true);
      }
    }
    if (cart.open && !form.hidden) showOffer();
  });
  joinButton.addEventListener('click', async () => {
    if (submitting || !popup.open || quantity === 0) return;
    const address = email.value.trim().toLowerCase();
    if (joinedEmails.has(address)) { showSuccess(); return; }
    setSubmitting(true, false);
    try {
      await sendResearch('');
      joinedEmails.add(address);
      showSuccess();
    } catch (_error) {
      closePopup();
      showError('Failed to send. Please try again.');
    } finally {
      setSubmitting(false, false);
    }
  });
  renderCart();
})();
